import { createBrowserRouter } from 'react-router-dom'
import PublicRoute from '../components/PublicRoute'
import AddCompanyPage from '../pages/AddCompanyPage'
import SelfAssessmentEntry from '../pages/SelfAssessmentEntry'
import CompaniesPage from '../pages/SupportPage'
import CompanyDetailPage from '../pages/CompanyDetailPage'
import CT600Filling from '../pages/CT600Filling'
import ErrorPage from '../pages/ErrorPage'
import HistoryPage from '../pages/HistoryPage'
import AssessmentDetailPage from '../pages/AssessmentDetailPage'
import ForgetPassword from '../pages/forgetPassword'
import PaymentCancelledPage from '../pages/PaymentCancelledPage'
import PaymentSuccessPage from '../pages/PaymentSuccessPage'
import PricingPage from '../pages/PricingPage'
import HelpCenterPage from '../pages/HelpCenterPage'
import DashboardPage from '../pages/HomePage'
import HmrcAuthCallback from '../pages/HmrcAuthCallback'
import LandingPage from '../pages/Landing'
import AuthLoadingPage from '../pages/loading'
import Login from '../pages/login'
import AdminLoginPage from '../pages/AdminLoginPage'
import Register from '../pages/register'
import ResetPassword from '../pages/resetPassword'
import SelfAssessmentAccountPage from '../pages/SelfAssessmentAccountPage'
import AdminDashboardPage from '../pages/AdminDashboardPage'
import AdminCompanyManagementPage from '../pages/AdminCompanyManagementPage'
import AdminFilingManagementPage from '../pages/AdminFilingManagementPage'
import AdminFilingDetailPage from '../pages/AdminFilingDetailPage'
import AdminFinanceBalancePage from '../pages/AdminFinanceBalancePage'
import AdminUsersManagementPage from '../pages/AdminUsersManagementPage'
import AdminAdminManagementPage from '../pages/AdminAdminManagementPage'
import AdminUserDetailPage from '../pages/AdminUserDetailPage'
import AdminReportsPage from '../pages/AdminReportsPage'
import AdminSettingsPage from '../pages/AdminSettingsPage'
import AdminCompanyDetailPage from '../pages/AdminCompanyDetailPage'
import SettingsPage from '../pages/SettingsPage'
import AuthRegisterLoadingPage from '../pages/signUpLoading'
import VerifyOtp from '../pages/veifyOtp'
import VerifySignUp from '../pages/verifySignIn'
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage'
import CompaniesHouseFilingPage from '../pages/CompaniesHouseFilingPage'
import CompaniesHouseAuthCallback from '../pages/CompaniesHouseAuthCallback'
import AboutPage from '../pages/AboutPage'
import FeaturesPage from '../pages/FeaturesPage'
import TermsPage from '../pages/TermsPage'

export const router = createBrowserRouter([
  {
    path: '/',
    // element: <MainLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: (
          <PublicRoute>
            <LandingPage />
          </PublicRoute>
        ),
      },
      {
        path: 'login',
        element: (
          <PublicRoute>
            <Login />
          </PublicRoute>
        ),
      },
      {
        path: 'admin/login',
        element: (
          <PublicRoute>
            <AdminLoginPage />
          </PublicRoute>
        ),
      },
      {
        path: 'sign-up',
        element: (
          <PublicRoute>
            <Register />
          </PublicRoute>
        ),
      },
      {
        path: 'forgot-password',
        element: (
          <PublicRoute>
            <ForgetPassword />
          </PublicRoute>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        ),
      },
      {
        path: 'verify-otp',
        element: (
          <PublicRoute>
            <VerifyOtp />
          </PublicRoute>
        ),
      },
      {
        path: 'verify-sign-up',
        element: (
          <PublicRoute>
            <VerifySignUp />
          </PublicRoute>
        ),
      },
      {
        path: 'loading',
        element: (
          <PublicRoute>
            <AuthLoadingPage />
          </PublicRoute>
        ),
      },
      {
        path: 'registering',
        element: (
          <PublicRoute>
            <AuthRegisterLoadingPage />
          </PublicRoute>
        ),
      },
      {
        path: 'help-center',
        element: <HelpCenterPage />,
      },
      {
        path: 'features',
        element: (
          <PublicRoute>
            <FeaturesPage />
          </PublicRoute>
        ),
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: 'terms',
        element: <TermsPage />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'admin/dashboard',
        element: <AdminDashboardPage />,
      },
      {
        path: 'admin/companies',
        element: <AdminCompanyManagementPage />,
      },
      {
        path: 'admin/companies/:id',
        element: <AdminCompanyDetailPage />,
      },
      {
        path: 'admin/filings',
        element: <AdminFilingManagementPage />,
      },
      {
        path: 'admin/filings/:id',
        element: <AdminFilingDetailPage />,
      },
      {
        path: 'admin/finance',
        element: <AdminFinanceBalancePage />,
      },
      {
        path: 'admin/users',
        element: <AdminUsersManagementPage />,
      },
      {
        path: 'admin/users/:id',
        element: <AdminUserDetailPage />,
      },
      {
        path: 'admin/admins',
        element: <AdminAdminManagementPage />,
      },
      {
        path: 'admin/reports',
        element: <AdminReportsPage />,
      },
      {
        path: 'admin/settings',
        element: <AdminSettingsPage />,
      },
      {
        path: 'history',
        element: <HistoryPage />,
      },
      {
        path: 'assessment/:id',
        element: <AssessmentDetailPage />,
      },
      {
        path: 'companies',
        element: <CompaniesPage />,
      },
      {
        path: 'company/:id',
        element: <CompanyDetailPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'add-company',
        element: <AddCompanyPage />,
      },
      {
        // Canonical single entry for the Self-Assessment flow (launcher → wizard).
        path: 'self-assessment/filing',
        element: <SelfAssessmentEntry />,
      },
      {
        // Legacy alias; resolves to the same launcher/wizard gate for back-compat.
        path: 'add-self-assessment',
        element: <SelfAssessmentEntry />,
      },
      {
        path: 'ct600-filing',
        element: <CT600Filling />,
      },
      {
        path: 'ct600-filing/:id',
        element: <CT600Filling />,
      },
      {
        path: 'companies-house-filing',
        element: <CompaniesHouseFilingPage />,
      },
      {
        path: 'auth/hmrc/callback',
        element: <HmrcAuthCallback />,
      },
      {
        path: 'auth/companies-house/callback',
        element: <CompaniesHouseAuthCallback />,
      },
      {
        path: 'self-assessment/account',
        element: <SelfAssessmentAccountPage />,
      },
      {
        path: 'pricing',
        element: <PricingPage />,
      },
      {
        path: 'payment/success',
        element: <PaymentSuccessPage />,
      },
      {
        path: 'payment/cancelled',
        element: <PaymentCancelledPage />,
      },
      {
        path: 'about',
        element: (
          <PublicRoute>
            <AboutPage />
          </PublicRoute>
        ),
      },
    ],
  },
])

export default router
